import { AccommodationRecommendationsProvider } from './AccommodationRecommendationsProvider';

export default AccommodationRecommendationsProvider;
